export default __webpack_public_path__ + "static/media/carouselSeven.504ad56d.png";